import React from 'react';
import { useTranslation } from 'react-i18next';
import { printDateTime } from '@guryou/utils';

const Sessions = ({ service }) => {
  const { t } = useTranslation();

  if (!service || !service.sessions || service.sessions.length === 0) {
    return (
      <div className="text-center py-8">
        <p className="text-gray-500">{t('SESSIONS.noSessionsInClass')}</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {service.sessions.map((session, i) => (
        <div key={i} className="p-4 border border-gray-200 rounded-lg hover:border-gray-300 transition-colors">
          <div className="space-y-2">
            <div className="flex items-center justify-between">
              <span className="text-sm font-medium text-gray-700">{t('GENERAL.from')}</span>
              <span className="text-sm text-gray-900">{printDateTime(session.startTime)}</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm font-medium text-gray-700">{t('GENERAL.to')}</span>
              <span className="text-sm text-gray-900">{printDateTime(session.endTime)}</span>
            </div>
            {session.resourceName && (
              <div className="flex items-center justify-between pt-2 border-t border-gray-100">
                <span className="text-sm font-medium text-gray-700">{t('PROFILE.resource')}</span>
                <span className="text-sm text-gray-900">{session.resourceName}</span>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Sessions;
